module.exports = __webpack_public_path__ + "img/dayin.b579f50b.svg";